import MuiAvatar from '@mui/material/Avatar';
import { css } from '@src/common/styles/Styles';
import { theme } from '@src/common/styles/Theme';
import { User01 } from '@untitled-ui/icons-react';

interface Props {
  width?: number;
  height?: number;
}

export const Avatar = ({ width = 42, height = 42 }: Props) => {
  const avatar = css({
    width,
    height,
    backgroundColor: theme.palette.primary.primaryContainer,
  });

  return (
    <MuiAvatar className={avatar}>
      <User01 color={theme.palette.primary.onPrimaryFixed} />
    </MuiAvatar>
  );
};
